function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultOptions = {
  // Default expire time is 1 year in seconds
  expires: 31536000,
  path: '/',
  secure: true,
  domain: window.location.hostname,
  samesite: 'Lax'
};
var ERR_NO_PARAMS = 'No params were passed';
var regReserved = /^(?:expires|max-age|path|domain|secure)$/i;
var ERR_RESERVED_WORD = 'Name cannot contain reserved cookie property names';
function cookie(name, value, opts) {
  if (!name) {
    throw new Error(ERR_NO_PARAMS);
  }

  var options = Object.assign({}, defaultOptions, opts);

  if (value || value === '') {
    return set(name, value, options);
  }

  return get(name);
} // Parameters
// name: The cookie name. Required.
// value: The cookie value. Required.
// options: Optional object
//   - expires: The age of the cookie in seconds.
//   - domain: The domain where the cookie will be readable.
//   - path: The path where the cookie will be readable.
//   - secure: The default is true.

function set(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (regReserved.test(name)) {
    throw new Error(ERR_RESERVED_WORD);
  }

  var expiresStr = '';

  if (options.expires) {
    var date = new Date();
    date.setTime(date.getTime() + options.expires * 1000);
    expiresStr = ';expires=' + date.toUTCString();
  }

  document.cookie = "".concat(name, "=").concat(value).concat(expiresStr, ";domain=").concat(options.domain, ";path=").concat(options.path, ";samesite:").concat(options.samesite, ";").concat(options.secure ? ';secure' : '');
} // Parameters
// name: The cookie name. Required.


function get(name) {
  // These special characters inside the cookie name should be escaped to be differentiated from the regex special characters.
  var regSpecial = /[.*+?^${}()|[\]\\]/g; // This regex removes all other strings except the value for the given cookie name.
  // It ignores any characters and/or white spaces ends with ; before the given cookie name, and
  // captures the string value between 'name = ' and either the end of string or ;.

  var value = document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + name.replace(regSpecial, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1') || null;
  return value;
}

var Environment;

(function (Environment) {
  Environment["ALPHA"] = "ALPHA";
  Environment["BETA"] = "BETA";
  Environment["GAMMA"] = "GAMMA";
  Environment["PROD"] = "PROD";
  Environment["DEV"] = "DEV";
  Environment["INT_TEST"] = "INT_TEST";
})(Environment || (Environment = {}));

var TokenType;

(function (TokenType) {
  TokenType["VISITOR"] = "VISITOR";
  TokenType["ADVERTISEMENT"] = "ADVERTISEMENT";
})(TokenType || (TokenType = {}));

var VISITOR_API = {
  ALPHA: 'https://vs-alpha.aws.amazon.com/token',
  BETA: 'https://vs-beta.aws.amazon.com/token',
  GAMMA: 'https://vs-gamma.aws.amazon.com/token',
  PROD: 'https://vs.aws.amazon.com/token',
  DEV: 'https://vs-alpha.aws.amazon.com/token',
  // For integration test
  INT_TEST: 'https://vs-beta.aws.amazon.com/token'
};
var ADVERTISEMENT_API_MAP = {
  ALPHA: 'https://vs-alpha.aws.amazon.com/vs/ad-token',
  BETA: 'https://vs-beta.aws.amazon.com/vs/ad-token',
  GAMMA: 'https://vs-gamma.aws.amazon.com/vs/ad-token',
  PROD: 'https://vs.aws.amazon.com/vs/ad-token',
  DEV: 'https://vs-alpha.aws.amazon.com/vs/ad-token',
  // For integration test
  INT_TEST: 'https://vs-beta.aws.amazon.com/vs/ad-token'
};
var CN_VISITOR_API = {
  ALPHA: 'https://alpha.d2c.marketing.aws.a2z.org.cn/vs/token',
  BETA: 'https://beta.d2c.marketing.aws.a2z.org.cn/vs/token',
  GAMMA: 'https://gamma.d2c.marketing.aws.a2z.org.cn/vs/token',
  PROD: 'https://d2c.amazonaws.cn/vs/token',
  DEV: 'https://alpha.d2c.marketing.aws.a2z.org.cn/vs/token',
  // For integration test
  INT_TEST: 'https://alpha.d2c.marketing.aws.a2z.org.cn/vs/token'
};
var VISITOR_API_MAP = {
  'aws-cn': CN_VISITOR_API,
  aws: VISITOR_API
};

// Module for handling the API request.
// Get VisitorService endpoint
function getVisitorServiceEndpoint() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var domain = opts.domain || window.location.hostname;
  var env = opts.env || Environment.DEV;

  switch (opts.tokenType) {
    case TokenType.ADVERTISEMENT:
      return ADVERTISEMENT_API_MAP[env];

    default:
      if (domain !== null && domain !== void 0 && domain.endsWith('.cn')) {
        return VISITOR_API_MAP['aws-cn'][env];
      }

      return VISITOR_API_MAP['aws'][env];
  }
} // Makes a post request to an API endpoint.
// API endpoint can be passed in as an option. If it's not given, we will use the visitorAPI for endpoint.

function callAPI() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = opts.api || getVisitorServiceEndpoint(opts);
  var data = {};

  if (opts.token) {
    data.token = opts.token;
  }

  var startTime = performance.now();

  if (!url) {
    return Promise.reject(new Error('URL is undefined'));
  }

  return fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    credentials: 'include'
  }).then(function (response) {
    var _opts$logger;

    // Measure performance of fetch
    var endTime = performance.now();
    var elapsedTime = endTime - startTime;
    (_opts$logger = opts.logger) === null || _opts$logger === void 0 ? void 0 : _opts$logger.info({
      timeTakenToFetchVID: String(elapsedTime)
    });
    var res = response;

    if (!res.ok) {
      var e = new Error('VisitorID service responses with the error status.');
      e.name = res.status.toString();
      throw e;
    }

    return response.json();
  }).then(function (data) {
    return data;
  });
}

var COOKIE_DOMAINS = ['ai.awsplayer.com', 'aicallcenter.awsplayer.com', 'aipackagetracker.awsplayer.com', 'aistylist.awsplayer.com', 'allthingsdistributed.com', 'amazon.care', 'amazonaws.com', 'amazongames.com', 'amazonevents.com', 'apn-portal.com', 'atlas.aws', 'aws-experience.com', 'aws-floor11.es', 'aws-partner-directory.com', 'aws-portal.amazon.com', 'aws-startup-lofts.com', 'aws-startuploft-emea.com', 'aws.amazon.com', 'aws.com', 'aws.training', 'awscloud.com', 'awseducate.com', 'awsevents.com', 'awslivestream.com', 'awsmediamagazine.com', 'awspartner.com', 'awssummit.kr', 'awsthinkbox.com', 'buildon.aws', 'calculator.aws', 'chime.aws', 'cloudendure.com', 'codecatalyst.aws', 'community.aws', 'constructs.dev', 'dohy8sp8i3s5p.cloudfront.net', // Hoswer CF endpoint
'elasticbeanstalk.com', 'freertos.org', 'gamedev.amazon.com', 'iotatlas.io', 'iotatlas.net', 'jam.aws.com', 'java.awsblog.com', 'learnsecurity.amazon.com', 'mobile.awsblog.com', 'newworld.com', 'opendistro.github.io', 'partnercentral.awspartner.com', 'phonetool.amazon.com', 'protectconnect.com', 'quicksight.aws', 'repost.aws', 'ruby.awsblog.com', 'sagemaker.readthedocs.io', 'sagemaker-examples.readthedocs.io', 'sagemaker-jumpstart-industry-pack.readthedocs.io', 'sesblog.amazon.com', 'skillbuilder.aws', 'smithy.io', 'startups.aws', 'thinkboxsoftware.com', // CN domains
'amazonaws.cn', 'amazoncloud.cn', 'awsevents.cn', 'webchat-aws.clink.cn'];
var VID_COOKIE_NAME = 'awsd2c-token-c';
var ADID_COOKIE_NAME = 'aws-token-a-c'; // Used to disable 1P VID cookie on the console for prism compatibility

var AWS_CONSOLE_DOMAINS = ['aws.amazon.com', 'aws.com'];
var VID_3P_COOKIE_NAME = 'awsd2c-token';
var ADID_3P_COOKIE_NAME = 'aws-token-a'; // Needed for consistent dialup - can be removed after removal of 1P cookie from console is complete

var ADOBE_MCM_COOKIE_NAME = 'AMCV_7742037254C95E840A4C98A6%40AdobeOrg';
var DISABLE_1P_COOKIE_DIALUP_PERCENT = 100;
var AD_COOKIE_DIALUP_PERCENT = 100; // Shortbread cookie name

var SHORTBREAD_COOKIE_NAME = 'awsccc'; // Error messages

var ERR_SHORTBREAD = 'It does not seem your site has onboarded to Shortbread. Onboarding to Shortbread is required for using Visitor ID Service.';
var SCODE_ORG_ID = 'awsme_scode';

function dialUp(percentage) {
  var mid = parseMIDFromCookie() || '';

  if (!mid || !percentage) {
    return false;
  }

  if (percentage <= 0) {
    return false;
  }

  return parseInt(mid, 36) % 100 < percentage;
}
function parseMIDFromCookie() {
  var midCookie = cookie(ADOBE_MCM_COOKIE_NAME);

  if (midCookie == null) {
    return '';
  } // the cookie value is pipe-delimited with format Key|Value|Key|Value


  var vals = decodeURIComponent(midCookie).split('|');

  if (vals.length < 2) {
    return '';
  }

  for (var i = 0; i < vals.length - 1; i++) {
    if (vals[i] === 'MCMID') {
      return vals[i + 1];
    }
  }

  return '';
}

var VisitorIdCookie = /*#__PURE__*/function () {
  function VisitorIdCookie() {
    _classCallCheck$1(this, VisitorIdCookie);

    _defineProperty$1(this, "cookieValue", void 0);

    _defineProperty$1(this, "payload", void 0);

    _defineProperty$1(this, "tokenExpiry", void 0);

    _defineProperty$1(this, "vid", void 0);

    // read the 3p cookie in the console because the 1p cookie won't be there - use dial up for gradual rollout
    if (AWS_CONSOLE_DOMAINS.includes(window.location.hostname) && dialUp(DISABLE_1P_COOKIE_DIALUP_PERCENT)) {
      this.cookieValue = cookie(VID_3P_COOKIE_NAME) || '';
    } else {
      this.cookieValue = cookie(VID_COOKIE_NAME) || '';
    }

    this.payload = this.getPayload();
    this.vid = this.payload.vid || '';
    this.tokenExpiry = this.payload.exp || 0;
  }

  _createClass$1(VisitorIdCookie, [{
    key: "getValue",
    value: function getValue() {
      return this.cookieValue;
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      if (this.cookieValue) {
        return decode$1(this.cookieValue);
      }

      return {};
    }
  }, {
    key: "hasValidValue",
    value: function hasValidValue() {
      return this.vid.length > 0 && !isTokenExpired$1(this.tokenExpiry);
    }
  }, {
    key: "set",
    value: function set(data, domain) {
      var options = {
        domain: domain || getCookieDomain$1(window.location.hostname),
        expires: 31536000 // 365 days in seconds

      }; // Do not set 1p cookie on the aws console for prism compatibility - just read the 3P cookie instead

      if (AWS_CONSOLE_DOMAINS.includes(window.location.hostname) && dialUp(DISABLE_1P_COOKIE_DIALUP_PERCENT)) {
        this.cookieValue = cookie(VID_3P_COOKIE_NAME) || '';
      } else {
        cookie(VID_COOKIE_NAME, data, options);
        this.cookieValue = cookie(VID_COOKIE_NAME) || '';
      }

      this.payload = this.getPayload();
      this.vid = this.payload.vid || this.vid;
      this.tokenExpiry = this.payload.exp || this.tokenExpiry;
    }
  }]);

  return VisitorIdCookie;
}();

function getCookieDomain$1(url) {
  var hostname = url.replace(/(^\w+:|^)\/\//, '').split(/[/?#]/)[0];
  var domainFound = COOKIE_DOMAINS.filter(function (domain) {
    if (hostname === domain) {
      return true;
    }

    var regex = new RegExp("(\\.?\\W|^)\\b".concat(domain, "\\b$"), 'gi');
    return regex.test(hostname);
  });

  if (domainFound.length > 0) {
    return domainFound[0];
  }

  return hostname;
}

function decode$1(value) {
  var jwsParts = value.split('.');

  if (jwsParts.length < 3) {
    return {};
  }

  var payload = value.split('.')[1];

  try {
    return JSON.parse(atob(payload));
  } catch (_unused) {
    return {};
  }
}

function isTokenExpired$1(timestamp) {
  if (!timestamp) {
    return true;
  }

  var expMillisec = timestamp * 1000;

  if (Date.now() >= expMillisec) {
    return true;
  }

  return false;
}

var dist = {};

Object.defineProperty(dist, '__esModule', {
  value: true
});

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) {
            if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
          }

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(_typeof(e) + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) {
      r.push(n);
    }

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
        "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BATCH_MANAGER_ENDPOINT = '/csds/collector/v1/events/batch';
var SCHEMA_VERSION = '1.0.0';
var BATCH_ID = 'D2CLogger';
var LogLevel;

(function (LogLevel) {
  LogLevel["INFO"] = "info";
  LogLevel["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));

var LOG_EVENT_TYPE = 'logEvent';
var BASEURL_MAP = {
  DEV: 'https://alpha.d2c.marketing.aws.dev',
  ALPHA: 'https://alpha.d2c.marketing.aws.dev',
  BETA: 'https://beta.d2c.marketing.aws.dev',
  GAMMA: 'https://gamma.d2c.marketing.aws.dev',
  PROD: 'https://d2c.aws.amazon.com',
  INT_TEST: 'https://d2c.aws.amazon.com'
};
var BASEURL_MAP_CN = {
  DEV: 'https://alpha.d2c.marketing.aws.a2z.org.cn',
  ALPHA: 'https://alpha.d2c.marketing.aws.a2z.org.cn',
  BETA: 'https://beta.d2c.marketing.aws.a2z.org.cn',
  GAMMA: 'https://gamma.d2c.marketing.aws.a2z.org.cn',
  PROD: 'https://d2c.amazonaws.cn',
  INT_TEST: 'https://alpha.d2c.marketing.aws.a2z.org.cn'
};
/**
 * Determines the base URL (not including path) based on the stage
 * @returns the base URL to use for API calls
 */

function getD2CBaseURL(stage) {
  if (window.location.hostname.endsWith('.cn')) {
    return BASEURL_MAP_CN[stage];
  }

  return BASEURL_MAP[stage];
}

var D2CBatchEventRequest = /*#__PURE__*/_createClass(function D2CBatchEventRequest(batchId, schemaVersion, batchEvents) {
  _classCallCheck(this, D2CBatchEventRequest);

  this.batchId = batchId;
  this.schemaVersion = schemaVersion;
  this.batchEvents = batchEvents;
});

var D2CEvent = /*#__PURE__*/_createClass(function D2CEvent(pageURL, eventType, eventTimestamp, customData, orgId) {
  _classCallCheck(this, D2CEvent);

  this.pageURL = pageURL;
  this.eventType = eventType;
  this.eventTimestamp = eventTimestamp;
  this.customData = customData;
  this.orgId = orgId;
});
/**
 * A generic wrapper for making POST calls
 * @param baseUrl - The path to which to make the request (we append this to base url)
 * @param options - The options for the POST call, fetch style
 * @return a Promise for the response
 */


function post(baseUrl, options) {
  return fetch("".concat(baseUrl).concat(BATCH_MANAGER_ENDPOINT), _objectSpread2({
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }, options))["catch"](function (error) {
    console.log(error);
  });
}
/**
 * Sends a batch of events to the API.
 * @param baseUrl - The url to which to send the batch (we append the path to this base url)
 * @param options - The options for the POST call, fetch style
 * @return a Promise for the response
 */


function sendBatch(_x, _x2) {
  return _sendBatch.apply(this, arguments);
}

function _sendBatch() {
  _sendBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseUrl, options) {
    var body;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = JSON.stringify(options.batchEventRequest);
            _context.next = 3;
            return post(baseUrl, _objectSpread2(_objectSpread2({}, options), {}, {
              body: body
            }));

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendBatch.apply(this, arguments);
}

var batchTimeMS = 200; // Batch request timeout in milliseconds

/**
 * Event listner for visibility change of the document
 * @param flushQueue - Function to empty the logQueue
 */

var addVisibilityChangeListener = function addVisibilityChangeListener(flushQueue) {
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flushQueue();
    }
  });
};

var BatchManager = /*#__PURE__*/function () {
  function BatchManager(stage, orgId) {
    var _this = this;

    _classCallCheck(this, BatchManager);

    this.logQueue = [];
    /**
     * Flushes the log queue by sending a batch request if the queue is not empty
     */

    this.flushQueue = function () {
      if (_this.logQueue.length) {
        _this.sendBatchRequest(true);
      }
    };

    this.maxBatchSize = 10;
    this.baseUrl = getD2CBaseURL(stage.toUpperCase());
    this.orgId = orgId; // setup event listener

    addVisibilityChangeListener(this.flushQueue);
  }
  /**
   * Creates a log entry with the given data
   * @param data - custom data to be logged
   */


  return _createClass(BatchManager, [{
    key: "createLog",
    value: function createLog(customData) {
      if (Object.keys(customData).length > 0) {
        var d2cEvent = new D2CEvent(window.location.toString(), LOG_EVENT_TYPE, new Date().getTime(), customData, this.orgId);
        this.logQueue.push(d2cEvent);

        if (this.logQueue.length === this.maxBatchSize) {
          return this.sendBatchRequest();
        } // refreshing timer to minimize batch calls


        if (this.batchTimer !== undefined) {
          return this.refreshBatchTimer();
        }

        this.batchTimer = this.createBatchTimer();
      }

      return;
    }
    /**
     * Creates a new batch event request with the contents of the logQueue
     */

  }, {
    key: "createBatchRequest",
    value: function createBatchRequest() {
      return new D2CBatchEventRequest(BATCH_ID, SCHEMA_VERSION, this.logQueue);
    }
    /**
     * Asynchronously sends a batch request with the keepalive option disabled
     * @param keepalive
     */

  }, {
    key: "sendBatchRequest",
    value: function () {
      var _sendBatchRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var keepalive,
            batchEventRequest,
            _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keepalive = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                batchEventRequest = this.createBatchRequest();
                _context.next = 4;
                return sendBatch(this.baseUrl, {
                  batchEventRequest: batchEventRequest,
                  keepalive: keepalive
                });

              case 4:
                this.logQueue = [];
                clearTimeout(this.batchTimer);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendBatchRequest() {
        return _sendBatchRequest.apply(this, arguments);
      }

      return sendBatchRequest;
    }()
    /**
     * Creates a batch timer to send batch requests at a regular interval
     * @returns The ID of the created Timer
     */

  }, {
    key: "createBatchTimer",
    value: function createBatchTimer() {
      var _this2 = this;

      return setTimeout(function () {
        _this2.sendBatchRequest();
      }, batchTimeMS);
    }
    /**
     * Refreshes the batch timer by clearing the existing timire and creating a new one
     */

  }, {
    key: "refreshBatchTimer",
    value: function refreshBatchTimer() {
      clearTimeout(this.batchTimer);
      this.batchTimer = this.createBatchTimer();
    }
  }]);
}();

var AWSD2CLogger = /*#__PURE__*/function () {
  function AWSD2CLogger(stage, orgId) {
    _classCallCheck(this, AWSD2CLogger);

    this.batchManager = new BatchManager(stage, orgId);
  }

  return _createClass(AWSD2CLogger, [{
    key: "error",
    value: function error(customData) {
      customData = _objectSpread2(_objectSpread2({}, customData), {}, {
        logLevel: LogLevel.ERROR
      });
      this.batchManager.createLog(customData);
    }
  }, {
    key: "info",
    value: function info(customData) {
      customData = _objectSpread2(_objectSpread2({}, customData), {}, {
        logLevel: LogLevel.INFO
      });
      this.batchManager.createLog(customData);
    }
  }]);
}();

var AWSD2CLogger_1 = dist.AWSD2CLogger = AWSD2CLogger;

window.AWSMA = window.AWSMA || {};
var vidCallbackQueue = [];
var tokenCallbackQueue = [];
var vidCookie; // Globally accessible function to get the visitorId value when the visitorId cookie is set.
// This is needed for services like Panorama to access the visitor id value on the Marketing website without adding duplicate visitorId client code.
// If the valid visitorId cookie value is available, trigger the callback with that value.
// Otherwise, push the callback to the queue. The queue will be flushed when the visitorId cookie is set.
// Parameter
// cb: Callback function accepting visitor id.

AWSMA.visitorIdReady = function (cb) {
  if (vidCookie && vidCookie.hasValidValue()) {
    cb(vidCookie.getPayload().vid || '');
  } else {
    vidCallbackQueue.push(cb);
  }
}; // Globally accessible function to get the token value when the token cookie is set.
// cb: Callback function accepting token.


AWSMA.tokenReady = function (cb) {
  if (vidCookie && vidCookie.hasValidValue() && vidCookie.getValue()) {
    cb(vidCookie.getValue() || '');
  } else {
    tokenCallbackQueue.push(cb);
  }
};

var AWSVisitorIdClient = /*#__PURE__*/function () {
  function AWSVisitorIdClient(opts) {
    var _opts$env;

    _classCallCheck$1(this, AWSVisitorIdClient);

    _defineProperty$1(this, "vidCookie", void 0);

    _defineProperty$1(this, "visitorId", void 0);

    _defineProperty$1(this, "visitorToken", void 0);

    _defineProperty$1(this, "options", void 0);

    _defineProperty$1(this, "logger", void 0);

    if (cookie(SHORTBREAD_COOKIE_NAME) === null) {
      console.error(ERR_SHORTBREAD);
      throw new Error(ERR_SHORTBREAD);
    }

    this.options = opts;
    this.vidCookie = new VisitorIdCookie();
    vidCookie = this.vidCookie;
    this.visitorId = '';
    this.visitorToken = {};

    if (!opts.cookieAllowed) {
      this.invokeVisitorIdReady();
      this.invokeTokenReady();
      return;
    }

    this.setVisitorId();
    var stage = Environment[(_opts$env = opts.env) !== null && _opts$env !== void 0 ? _opts$env : 'INT_TEST'];
    this.logger = new AWSD2CLogger_1(stage, SCODE_ORG_ID);
  } // Get the vid only from the visitor cookie value


  _createClass$1(AWSVisitorIdClient, [{
    key: "getVisitorId",
    value: function getVisitorId(opts) {
      var _this = this;

      this.getVisitorToken({
        domain: opts.domain,
        onError: opts.onError,
        onSuccess: function onSuccess(data) {
          if (data.vid && typeof opts.onSuccess === 'function') {
            opts.onSuccess(data.vid);

            _this.invokeVisitorIdReady();
          }
        }
      });
    } // Trigger onSuccess callback immediately if a valid visitor id exists.
    // Otherwise, make a request to Visitor ID service API and get the new visitor cookie value.

  }, {
    key: "getVisitorToken",
    value: function getVisitorToken(opts) {
      var _this2 = this;

      if (this.vidCookie.getValue() && this.hasValidVisitorId()) {
        if (typeof opts.onSuccess === 'function') {
          opts.onSuccess(this.visitorToken);
        }

        return;
      }

      callAPI({
        token: this.vidCookie.getValue(),
        tokenType: TokenType.VISITOR,
        env: this.options.env,
        domain: opts.domain,
        logger: this.logger
      }).then(function (data) {
        if (data.token) {
          _this2.vidCookie.set(data.token, opts.domain);

          _this2.setVisitorId();

          _this2.invokeVisitorIdReady();

          _this2.invokeTokenReady();
        }

        if (typeof opts.onSuccess === 'function') {
          opts.onSuccess(_this2.visitorToken);
        }
      })["catch"](function (e) {
        _this2.invokeVisitorIdReady();

        _this2.invokeTokenReady();

        if (typeof opts.onError === 'function') {
          opts.onError(e);
        }
      });
    }
  }, {
    key: "setVisitorId",
    value: function setVisitorId() {
      var vidPayload = this.vidCookie.getPayload();
      this.visitorToken = vidPayload || {};
      this.visitorId = vidPayload.vid || '';
    }
  }, {
    key: "hasValidVisitorId",
    value: function hasValidVisitorId() {
      return this.vidCookie.hasValidValue();
    }
  }, {
    key: "getExistingVisitorId",
    value: function getExistingVisitorId() {
      return this.visitorId;
    }
  }, {
    key: "getExistingVisitorToken",
    value: function getExistingVisitorToken() {
      return this.visitorToken;
    }
  }, {
    key: "getExistingToken",
    value: function getExistingToken() {
      return this.vidCookie.getValue();
    }
    /**
     * Executes every registered callback in the vidCallbackQueue, passing the visitor ID value in.
     */

  }, {
    key: "invokeVisitorIdReady",
    value: function invokeVisitorIdReady() {
      while (vidCallbackQueue.length > 0) {
        var cb = vidCallbackQueue.shift();

        if (typeof cb === 'function') {
          cb(this.visitorId);
        }
      }
    }
    /**
     * Executes every registered callback in the tokenCallbackQueue, passing the token value in.
     */

  }, {
    key: "invokeTokenReady",
    value: function invokeTokenReady() {
      while (tokenCallbackQueue.length > 0) {
        var cb = tokenCallbackQueue.shift();

        if (typeof cb === 'function') {
          cb(this.vidCookie.getValue());
        }
      }
    }
  }]);

  return AWSVisitorIdClient;
}();

var AdvertisementIdCookie = /*#__PURE__*/function () {
  function AdvertisementIdCookie() {
    _classCallCheck$1(this, AdvertisementIdCookie);

    _defineProperty$1(this, "cookieValue", void 0);

    _defineProperty$1(this, "payload", void 0);

    _defineProperty$1(this, "tokenExpiry", void 0);

    _defineProperty$1(this, "advertisementId", void 0);

    if (AWS_CONSOLE_DOMAINS.includes(window.location.hostname) && dialUp(DISABLE_1P_COOKIE_DIALUP_PERCENT)) {
      this.cookieValue = cookie(ADID_3P_COOKIE_NAME) || '';
    } else {
      this.cookieValue = cookie(ADID_COOKIE_NAME) || '';
    }

    this.payload = this.getPayload();
    this.advertisementId = this.payload.aid || '';
    this.tokenExpiry = this.payload.exp || 0;
  }

  _createClass$1(AdvertisementIdCookie, [{
    key: "getValue",
    value: function getValue() {
      return this.cookieValue;
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      if (this.cookieValue) {
        return decode(this.cookieValue);
      }

      return {};
    }
  }, {
    key: "hasValidValue",
    value: function hasValidValue() {
      return this.advertisementId.length > 0 && !isTokenExpired(this.tokenExpiry);
    }
  }, {
    key: "set",
    value: function set(data, domain) {
      var options = {
        domain: domain || getCookieDomain(window.location.hostname),
        expires: 31536000 // 365 days in seconds

      };

      if (AWS_CONSOLE_DOMAINS.includes(window.location.hostname) && dialUp(DISABLE_1P_COOKIE_DIALUP_PERCENT)) {
        this.cookieValue = cookie(ADID_3P_COOKIE_NAME) || '';
      } else {
        cookie(ADID_COOKIE_NAME, data, options);
        this.cookieValue = cookie(ADID_COOKIE_NAME) || '';
      }

      this.payload = this.getPayload();
      this.advertisementId = this.payload.aid || this.advertisementId;
      this.tokenExpiry = this.payload.exp || this.tokenExpiry;
    }
  }]);

  return AdvertisementIdCookie;
}();

function getCookieDomain(url) {
  var hostname = url.replace(/(^\w+:|^)\/\//, '').split(/[/?#]/)[0];
  var domainFound = COOKIE_DOMAINS.filter(function (domain) {
    if (hostname === domain) {
      return true;
    }

    var regex = new RegExp("(\\.?\\W|^)\\b".concat(domain, "\\b$"), 'gi');
    return regex.test(hostname);
  });

  if (domainFound.length > 0) {
    return domainFound[0];
  }

  return hostname;
}

function decode(value) {
  var jwsParts = value.split('.');

  if (jwsParts.length < 3) {
    return {};
  }

  var payload = value.split('.')[1];

  try {
    return JSON.parse(atob(payload));
  } catch (_unused) {
    return {};
  }
}

function isTokenExpired(timestamp) {
  if (!timestamp) {
    return true;
  }

  var expMillisec = timestamp * 1000;

  if (Date.now() >= expMillisec) {
    return true;
  }

  return false;
}

window.AWSMA = window.AWSMA || {};
var adIdCallbackQueue = [];
var adTokenCallbackQueue = [];
var adIdCookie; // Globally accessible function to get the advertisementId value when the advertisementId cookie is set.
// This is needed for services like Panorama to access the advertisement id value on the Marketing website without adding duplicate advertisementId client code.
// If the valid advertisementId cookie value is available, trigger the callback with that value.
// Otherwise, push the callback to the queue. The queue will be flushed when the advertisementId cookie is set.
// Parameter
// cb: Callback function accepting advertisement id.

AWSMA.advertisementIdReady = function (cb) {
  if (adIdCookie && adIdCookie.hasValidValue()) {
    cb(adIdCookie.getPayload().aid || '');
  } else {
    adIdCallbackQueue.push(cb);
  }
}; // Globally accessible function to get the token value when the token cookie is set.
// cb: Callback function accepting token.


AWSMA.tokenReady = function (cb) {
  if (adIdCookie && adIdCookie.hasValidValue() && adIdCookie.getValue()) {
    cb(adIdCookie.getValue() || '');
  } else {
    adTokenCallbackQueue.push(cb);
  }
};

var AWSAdvertisementIdClient = /*#__PURE__*/function () {
  function AWSAdvertisementIdClient(opts) {
    var _opts$env;

    _classCallCheck$1(this, AWSAdvertisementIdClient);

    _defineProperty$1(this, "adIdCookie", void 0);

    _defineProperty$1(this, "advertisementId", void 0);

    _defineProperty$1(this, "advertisementToken", void 0);

    _defineProperty$1(this, "options", void 0);

    _defineProperty$1(this, "logger", void 0);

    if (cookie(SHORTBREAD_COOKIE_NAME) === null) {
      console.error(ERR_SHORTBREAD);
      throw new Error(ERR_SHORTBREAD);
    }

    this.options = opts;
    this.adIdCookie = new AdvertisementIdCookie();
    adIdCookie = this.adIdCookie;
    this.advertisementId = '';
    this.advertisementToken = {};

    if (!opts.cookieAllowed) {
      this.invokeAdvertisementIdReady();
      this.invokeTokenReady();
      return;
    }

    this.setAdvertisementId();
    var stage = Environment[(_opts$env = opts.env) !== null && _opts$env !== void 0 ? _opts$env : 'INT_TEST'];
    this.logger = new AWSD2CLogger_1(stage, SCODE_ORG_ID);
  } // Get the advertisementId only from the advertisement cookie value


  _createClass$1(AWSAdvertisementIdClient, [{
    key: "getAdvertisementId",
    value: function getAdvertisementId(opts) {
      var _this = this;

      this.getAdvertisementToken({
        domain: opts.domain,
        onError: opts.onError,
        onSuccess: function onSuccess(data) {
          if (data.aid && typeof opts.onSuccess === 'function') {
            opts.onSuccess(data.aid);

            _this.invokeAdvertisementIdReady();
          }
        }
      });
    } // Trigger onSuccess callback immediately if a valid advertisement id exists.
    // Otherwise, make a request to Advertisement ID service API and get the new advertisement cookie value.

  }, {
    key: "getAdvertisementToken",
    value: function getAdvertisementToken(opts) {
      var _this2 = this;

      if (!dialUp(AD_COOKIE_DIALUP_PERCENT)) {
        return;
      }

      if (this.adIdCookie.getValue() && this.hasValidAdvertisementId()) {
        if (typeof opts.onSuccess === 'function') {
          opts.onSuccess(this.advertisementToken);
        }

        return;
      }

      callAPI({
        token: this.adIdCookie.getValue(),
        tokenType: TokenType.ADVERTISEMENT,
        env: this.options.env,
        domain: opts.domain,
        logger: this.logger
      }).then(function (data) {
        if (data.token) {
          _this2.adIdCookie.set(data.token, opts.domain);

          _this2.setAdvertisementId();

          _this2.invokeAdvertisementIdReady();

          _this2.invokeTokenReady();
        }

        if (typeof opts.onSuccess === 'function') {
          opts.onSuccess(_this2.advertisementToken);
        }
      })["catch"](function (e) {
        _this2.invokeAdvertisementIdReady();

        _this2.invokeTokenReady();

        if (typeof opts.onError === 'function') {
          opts.onError(e);
        }
      });
    }
  }, {
    key: "setAdvertisementId",
    value: function setAdvertisementId() {
      var adIdPayload = this.adIdCookie.getPayload();
      this.advertisementToken = adIdPayload || {};
      this.advertisementId = adIdPayload.aid || '';
    }
  }, {
    key: "hasValidAdvertisementId",
    value: function hasValidAdvertisementId() {
      return this.adIdCookie.hasValidValue();
    }
  }, {
    key: "getExistingAdvertisementId",
    value: function getExistingAdvertisementId() {
      return this.advertisementId;
    }
  }, {
    key: "getExistingAdvertisementToken",
    value: function getExistingAdvertisementToken() {
      return this.advertisementToken;
    }
  }, {
    key: "getExistingToken",
    value: function getExistingToken() {
      return this.adIdCookie.getValue();
    }
    /**
     * Executes every registered callback in the adIdCallbackQueue, passing the advertisement ID value in.
     */

  }, {
    key: "invokeAdvertisementIdReady",
    value: function invokeAdvertisementIdReady() {
      while (adIdCallbackQueue.length > 0) {
        var cb = adIdCallbackQueue.shift();

        if (typeof cb === 'function') {
          cb(this.advertisementId);
        }
      }
    }
    /**
     * Executes every registered callback in the adTokenCallbackQueue, passing the token value in.
     */

  }, {
    key: "invokeTokenReady",
    value: function invokeTokenReady() {
      while (adTokenCallbackQueue.length > 0) {
        var cb = adTokenCallbackQueue.shift();

        if (typeof cb === 'function') {
          cb(this.adIdCookie.getValue());
        }
      }
    }
  }]);

  return AWSAdvertisementIdClient;
}();

export { AWSAdvertisementIdClient, AWSVisitorIdClient, Environment, adIdCallbackQueue, adTokenCallbackQueue, tokenCallbackQueue, vidCallbackQueue };
//# sourceMappingURL=index.js.map
